import { ColorsEnum } from "../enums/colors.enum";

export const colorOrder: Array<ColorsEnum> = [
    ColorsEnum.orange,
    ColorsEnum.lightBlue,
    ColorsEnum.yellow,
    ColorsEnum.pink,
    ColorsEnum.magenta,
    ColorsEnum.orange
];